import React from "react";
import Flx from "../../../../components/layout/Flx";
import Htag from "../../../../components/typography/Htag";
import Txt from "../../../../components/typography/Txt";

const LiquidityCardSectionHeader = ({ title, subTitle, endContent, sx }) => (
  // Not `wrap`: a long subtitle wraps INSIDE the title column (flex 1) so the
  // end content stays on the right instead of dropping under the text.
  <Flx jb ac g={2} sx={{ mb: 1, ...sx }}>
    <Flx column g={0.25} sx={{ flex: 1, minWidth: 0 }}>
      <Htag
        h2
        sx={{
          fontSize: 16,
          fontWeight: 500,
          // fontSize: 17,
          // fontWeight: 600,
          color: "#0f172a",
          lineHeight: 1.2,
        }}
      >
        {title}
      </Htag>
      {subTitle && (
        <Txt
          //
          secondary
          // sx={{ fontSize: 11.5, color: grey[500] }}
        >
          {subTitle}
        </Txt>
      )}
    </Flx>
    {endContent ? <Flx ac sx={{ flexShrink: 0 }}>{endContent}</Flx> : null}
  </Flx>
);

export default LiquidityCardSectionHeader;
